// ===================================
// CYCLE DEFENDER LANDING PAGE
// Interactive Elements & Conversion Logic
// ===================================

// ===== INITIALIZATION =====
document.addEventListener('DOMContentLoaded', function() {
    initStickyNav();
    initStickyCTA();
    initCountdownTimer();
    initStockCounter();
    initExitIntent();
    initFAQAccordion();
    initSmoothScroll();
    initScrollAnimations();
    initSupplementFactsToggle();
});

// ===== STICKY NAVIGATION =====
function initStickyNav() {
    const nav = document.querySelector('.top-nav');
    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll <= 0) {
            nav.style.boxShadow = 'none';
        } else {
            nav.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.5)';
        }
        
        lastScroll = currentScroll;
    });
}

// ===== STICKY CTA BAR =====
function initStickyCTA() {
    const stickyCTA = document.getElementById('sticky-cta');
    const heroSection = document.getElementById('hero-section');
    const orderSection = document.getElementById('order-section');
    
    if (!stickyCTA || !heroSection) return;
    
    window.addEventListener('scroll', () => {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const currentScroll = window.pageYOffset;
        const windowHeight = window.innerHeight;
        
        // Show sticky CTA after hero section
        if (currentScroll > heroBottom && !isInViewport(orderSection)) {
            stickyCTA.classList.add('visible');
        } else {
            stickyCTA.classList.remove('visible');
        }
    });
}

// Helper function to check if element is in viewport
function isInViewport(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.bottom >= 0
    );
}

// ===== COUNTDOWN TIMER =====
function initCountdownTimer() {
    const timerElement = document.getElementById('countdown-timer');
    if (!timerElement) return;
    
    // Set countdown to 24 hours from now
    const endTime = new Date();
    endTime.setHours(endTime.getHours() + 24);
    
    function updateTimer() {
        const now = new Date().getTime();
        const distance = endTime - now;
        
        if (distance < 0) {
            // Reset to 24 hours when expired
            endTime.setTime(now + (24 * 60 * 60 * 1000));
            return;
        }
        
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        timerElement.textContent = 
            `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    
    updateTimer();
    setInterval(updateTimer, 1000);
}

// ===== STOCK COUNTER =====
function initStockCounter() {
    const stockElement = document.getElementById('stock-count');
    if (!stockElement) return;
    
    // Random stock between 15-30 for urgency
    const stockCount = Math.floor(Math.random() * 16) + 15;
    stockElement.textContent = stockCount;
    
    // Randomly decrease stock every 5-10 minutes
    setInterval(() => {
        const currentStock = parseInt(stockElement.textContent);
        if (currentStock > 10) {
            const shouldDecrease = Math.random() > 0.5;
            if (shouldDecrease) {
                stockElement.textContent = currentStock - 1;
                
                // Add pulse animation
                stockElement.parentElement.style.animation = 'pulse 0.5s ease';
                setTimeout(() => {
                    stockElement.parentElement.style.animation = '';
                }, 500);
            }
        }
    }, Math.random() * 300000 + 300000); // 5-10 minutes
}

// ===== EXIT INTENT POPUP =====
function initExitIntent() {
    const exitPopup = document.getElementById('exit-popup');
    const exitOverlay = document.getElementById('exit-overlay');
    const exitClose = document.getElementById('exit-close');
    const exitDecline = document.getElementById('exit-decline');
    
    if (!exitPopup || !exitOverlay) return;
    
    let exitIntentShown = false;
    let exitIntentClosed = false;
    
    // Show popup when mouse leaves viewport (desktop only)
    document.addEventListener('mouseout', function(e) {
        if (e.clientY <= 0 && !exitIntentShown && !exitIntentClosed && window.innerWidth > 768) {
            showExitPopup();
        }
    });
    
    // Show popup after 30 seconds on mobile
    if (window.innerWidth <= 768) {
        setTimeout(() => {
            if (!exitIntentShown && !exitIntentClosed) {
                showExitPopup();
            }
        }, 30000);
    }
    
    function showExitPopup() {
        exitPopup.classList.add('active');
        exitOverlay.classList.add('active');
        exitIntentShown = true;
        document.body.style.overflow = 'hidden';
    }
    
    function hideExitPopup() {
        exitPopup.classList.remove('active');
        exitOverlay.classList.remove('active');
        exitIntentClosed = true;
        document.body.style.overflow = '';
    }
    
    // Close handlers
    if (exitClose) {
        exitClose.addEventListener('click', hideExitPopup);
    }
    
    if (exitDecline) {
        exitDecline.addEventListener('click', hideExitPopup);
    }
    
    if (exitOverlay) {
        exitOverlay.addEventListener('click', hideExitPopup);
    }
    
    // Close on ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && exitIntentShown) {
            hideExitPopup();
        }
    });
    
    // Redirect to order section when clicking CTA in popup
    const exitCTA = exitPopup.querySelector('.btn-exit');
    if (exitCTA) {
        exitCTA.addEventListener('click', function(e) {
            hideExitPopup();
        });
    }
}

// ===== FAQ ACCORDION =====
function initFAQAccordion() {
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        
        if (question) {
            question.addEventListener('click', () => {
                // Close other items
                faqItems.forEach(otherItem => {
                    if (otherItem !== item && otherItem.classList.contains('active')) {
                        otherItem.classList.remove('active');
                    }
                });
                
                // Toggle current item
                item.classList.toggle('active');
            });
        }
    });
}

// ===== SMOOTH SCROLLING =====
function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            
            // Skip if href is just "#"
            if (href === '#') return;
            
            const targetElement = document.querySelector(href);
            if (targetElement) {
                e.preventDefault();
                
                const navHeight = document.querySelector('.top-nav')?.offsetHeight || 0;
                const targetPosition = targetElement.offsetTop - navHeight - 20;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}

// ===== SCROLL ANIMATIONS =====
function initScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-in');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    
    // Observe elements for animation
    const animatedElements = document.querySelectorAll(
        '.benefit-card, .problem-card, .ingredient-card, .testimonial-card, .usage-step, .pricing-card'
    );
    
    animatedElements.forEach(el => {
        observer.observe(el);
    });
}

// ===== CONVERSION TRACKING =====
function trackConversion(action, label) {
    // Console log for debugging
    console.log('Conversion Event:', action, label);
    
    // Add your analytics tracking here
    // Example for Google Analytics:
    // gtag('event', action, { 'event_label': label });
    
    // Example for Facebook Pixel:
    // fbq('track', action, { label: label });
}

// Track CTA clicks
document.addEventListener('click', function(e) {
    const target = e.target.closest('a, button');
    if (!target) return;
    
    // Track primary CTA clicks
    if (target.classList.contains('btn-primary') || 
        target.classList.contains('btn-primary-large') ||
        target.classList.contains('btn-sticky')) {
        trackConversion('subscribe_cta_click', target.textContent.trim());
    }
    
    // Track secondary CTA clicks
    if (target.classList.contains('btn-secondary') || 
        target.classList.contains('btn-secondary-large')) {
        trackConversion('onetime_cta_click', target.textContent.trim());
    }
    
    // Track "Get Protected Now" CTAs
    if (target.classList.contains('btn-large')) {
        trackConversion('benefit_cta_click', 'Get Protected Now');
    }
});

// ===== MOBILE OPTIMIZATION =====
function optimizeMobile() {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
        // Reduce animation complexity on mobile
        document.querySelectorAll('.product-showcase').forEach(el => {
            el.style.animation = 'none';
        });
    }
}

window.addEventListener('resize', optimizeMobile);
optimizeMobile();

// ===== PERFORMANCE OPTIMIZATION =====
// Lazy load images below fold
function initLazyLoad() {
    const images = document.querySelectorAll('img[data-src]');
    
    const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                imageObserver.unobserve(img);
            }
        });
    });
    
    images.forEach(img => imageObserver.observe(img));
}

// Call lazy load if needed
if (document.querySelectorAll('img[data-src]').length > 0) {
    initLazyLoad();
}

// ===== FORM VALIDATION (if needed in future) =====
function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

// ===== LOCAL STORAGE UTILITIES =====
function saveToLocalStorage(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error('localStorage error:', e);
    }
}

function getFromLocalStorage(key) {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (e) {
        console.error('localStorage error:', e);
        return null;
    }
}

// Save user interaction data
function trackUserBehavior() {
    const visits = getFromLocalStorage('visits') || 0;
    saveToLocalStorage('visits', visits + 1);
    
    const lastVisit = getFromLocalStorage('lastVisit');
    saveToLocalStorage('lastVisit', new Date().toISOString());
    
    // Show returning visitor message if appropriate
    if (visits > 0 && !document.querySelector('.returning-visitor-message')) {
        // Could add a welcome back message or special offer
        console.log('Returning visitor detected');
    }
}

trackUserBehavior();

// ===== URGENCY ELEMENTS REFRESH =====
function refreshUrgencyElements() {
    // Refresh countdown if it's at 00:00:00
    const timer = document.getElementById('countdown-timer');
    if (timer && timer.textContent === '00:00:00') {
        initCountdownTimer();
    }
}

// Refresh urgency elements every 5 minutes
setInterval(refreshUrgencyElements, 300000);

// ===== COMPARISON TABLE HIGHLIGHT =====
function initComparisonHighlight() {
    const table = document.querySelector('.comparison-table');
    if (!table) return;
    
    const highlightCol = table.querySelectorAll('.highlight-col');
    
    highlightCol.forEach(cell => {
        cell.addEventListener('mouseenter', function() {
            highlightCol.forEach(c => c.style.background = 'rgba(0, 214, 111, 0.15)');
        });
        
        cell.addEventListener('mouseleave', function() {
            const tds = table.querySelectorAll('td.highlight-col');
            tds.forEach(td => td.style.background = 'rgba(0, 214, 111, 0.05)');
        });
    });
}

initComparisonHighlight();

// ===== PRICING CARD SELECTION =====
function initPricingSelection() {
    const pricingCards = document.querySelectorAll('.pricing-card');
    
    pricingCards.forEach(card => {
        card.addEventListener('click', function(e) {
            // Don't trigger if clicking on CTA button
            if (e.target.closest('.btn-pricing')) return;
            
            const ctaButton = card.querySelector('.btn-pricing');
            if (ctaButton) {
                ctaButton.style.transform = 'scale(1.05)';
                setTimeout(() => {
                    ctaButton.style.transform = '';
                }, 200);
            }
        });
    });
}

initPricingSelection();

// ===== TESTIMONIAL ROTATION (Optional Enhancement) =====
function initTestimonialRotation() {
    const testimonials = document.querySelectorAll('.testimonial-card');
    if (testimonials.length === 0) return;
    
    let currentIndex = 0;
    
    // Only rotate on mobile to save space
    if (window.innerWidth <= 768) {
        // Hide all except first
        testimonials.forEach((card, index) => {
            if (index !== 0) {
                card.style.display = 'none';
            }
        });
        
        // Rotate every 5 seconds
        setInterval(() => {
            testimonials[currentIndex].style.display = 'none';
            currentIndex = (currentIndex + 1) % Math.min(3, testimonials.length);
            testimonials[currentIndex].style.display = 'block';
        }, 5000);
    }
}

// Uncomment if you want testimonial rotation on mobile
// initTestimonialRotation();

// ===== PRODUCT IMAGE GALLERY (for future enhancement) =====
function initImageGallery() {
    const productImages = document.querySelectorAll('.product-gallery-thumb');
    const mainImage = document.querySelector('.product-image');
    
    if (!mainImage || productImages.length === 0) return;
    
    productImages.forEach(thumb => {
        thumb.addEventListener('click', function() {
            const newSrc = this.dataset.fullsize || this.src;
            mainImage.src = newSrc;
            
            // Update active state
            productImages.forEach(t => t.classList.remove('active'));
            this.classList.add('active');
        });
    });
}

// Call if gallery exists
if (document.querySelector('.product-gallery-thumb')) {
    initImageGallery();
}

// ===== ACCESSIBILITY IMPROVEMENTS =====
function initAccessibility() {
    // Add keyboard navigation for FAQ
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(q => {
        q.setAttribute('role', 'button');
        q.setAttribute('tabindex', '0');
        
        q.addEventListener('keypress', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
    
    // Add aria-labels to icon-only buttons
    document.querySelectorAll('[class*="fa-"]').forEach(icon => {
        if (!icon.getAttribute('aria-label') && !icon.closest('[aria-label]')) {
            const parent = icon.closest('button, a');
            if (parent && !parent.textContent.trim()) {
                parent.setAttribute('aria-label', 'Icon button');
            }
        }
    });
}

initAccessibility();

// ===== SUPPLEMENT FACTS TOGGLE (Mobile-Friendly) =====
function initSupplementFactsToggle() {
    const toggle = document.getElementById('facts-toggle');
    const breakdown = document.getElementById('facts-breakdown');
    
    if (!toggle || !breakdown) return;
    
    toggle.addEventListener('click', function() {
        breakdown.classList.toggle('active');
        
        // Update button text
        const icon = this.querySelector('i');
        if (breakdown.classList.contains('active')) {
            icon.className = 'fas fa-times';
            this.innerHTML = '<i class="fas fa-times"></i> Close Breakdown';
        } else {
            icon.className = 'fas fa-list';
            this.innerHTML = '<i class="fas fa-list"></i> View Detailed Breakdown';
        }
        
        // Smooth scroll to breakdown on mobile
        if (window.innerWidth <= 768 && breakdown.classList.contains('active')) {
            setTimeout(() => {
                breakdown.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 100);
        }
    });
}

// ===== SCROLL PROGRESS INDICATOR (Optional) =====
function initScrollProgress() {
    const progressBar = document.createElement('div');
    progressBar.className = 'scroll-progress';
    progressBar.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #54D8D4 0%, #CAFBF2 100%);
        z-index: 10000;
        transition: width 0.1s ease;
    `;
    document.body.appendChild(progressBar);
    
    window.addEventListener('scroll', () => {
        const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (window.pageYOffset / windowHeight) * 100;
        progressBar.style.width = scrolled + '%';
    });
}

// Uncomment to enable scroll progress bar
// initScrollProgress();

// ===== ERROR HANDLING =====
window.addEventListener('error', function(e) {
    console.error('JavaScript error:', e.error);
    // Could send to error tracking service
});

// ===== PERFORMANCE MONITORING =====
if ('PerformanceObserver' in window) {
    const perfObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
            if (entry.entryType === 'navigation') {
                console.log('Page Load Time:', entry.loadEventEnd - entry.loadEventStart, 'ms');
            }
        }
    });
    
    try {
        perfObserver.observe({ entryTypes: ['navigation'] });
    } catch (e) {
        console.log('Performance monitoring not available');
    }
}

// ===== CONSOLE MESSAGE =====
console.log('%c⚡ Cycle Defender Landing Page Loaded', 'color: #54D8D4; font-size: 16px; font-weight: bold;');
console.log('%cHigh-converting design system initialized', 'color: #CAFBF2; font-size: 12px;');

// Export functions for external use if needed
window.CycleDefender = {
    trackConversion,
    saveToLocalStorage,
    getFromLocalStorage,
    validateEmail
};